import { TableBody } from '@material-ui/core';
import { Webhook } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { DeleteWebhookDialog } from '@/components/modules/Webhooks/components/dialogs/DeleteWebhookDialog';
import { EditWebhookDialog } from '@/components/modules/Webhooks/components/dialogs/EditWebhookDialog';
import { Row } from '@/components/modules/Webhooks/components/WebhooksTable/components/Row';
import { WebhooksTableProps } from '@/components/modules/Webhooks/components/WebhooksTable/WebhooksTable';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { DefaultTableProps } from '@/types/defaultTableProps';

export interface BodyProps extends WebhooksTableProps {
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  deleteView?: boolean;
}

export interface ActionHandleProps {
  item: Webhook;
}

export const Body = ({ webhooks, userId, tableProps, deleteView }: BodyProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const [menuAction, setMenuAction] = useState<TableMenuActions | undefined>();
  const [selectedItem, setSelectedItem] = useState<Webhook | undefined>();

  if (!userId || !webhooks || webhooks.length === 0) return null;

  const handleEdit = ({ item }: ActionHandleProps) => {
    setSelectedItem(item);
    setMenuAction(TableMenuActions.EDIT);
    toggleDialog();
  };

  const handleDelete = ({ item }: ActionHandleProps) => {
    setSelectedItem(item);
    setMenuAction(TableMenuActions.DELETE);
    toggleDialog();
  };

  return (
    <>
      <TableBody>
        {webhooks.map((webhook) => {
          return (
            <Row
              key={webhook.id}
              webhook={webhook}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              tableProps={tableProps}
              deleteView={deleteView}
            />
          );
        })}
      </TableBody>
      {menuAction === TableMenuActions.EDIT && selectedItem && opened && (
        <EditWebhookDialog
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          userId={userId}
          webhook={selectedItem}
        />
      )}

      {menuAction === TableMenuActions.DELETE && selectedItem && (
        <DeleteWebhookDialog
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          userId={userId}
          webhook={selectedItem}
        />
      )}
    </>
  );
};

export enum TableMenuActions {
  EDIT = 'edit',
  DELETE = 'delete',
}
